var map = {
	"./issue.js": 68,
	"./issue.js.es6": 68,
	"./label.js": 69,
	"./label.js.es6": 69,
	"./list.js": 70,
	"./list.js.es6": 70,
	"./milestone.js": 71,
	"./milestone.js.es6": 71,
	"./user.js": 72,
	"./user.js.es6": 72
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 161;


//////////////////
// WEBPACK FOOTER
// ./boards/models ^\.\/.*\.(js|es6)$
// module id = 161
// module chunks = 1